import { AuthContext, useAuthContext } from '@core/shared';
import { Container } from '@core/ui';
import { useContext, useMemo } from 'react';
import { Content } from '../Content';
import { CreateWebinarButton } from '../CreateWebinarButton';
import { ManageEnvironmentButton } from '../ManageEnvironmentButton';
import { SideNavBar } from '../SideNavBar';
import { NavBarMenuItem } from '../SideNavBar/types';
import { SubscribedWebinarsButton } from '../SubscribedWebinarsButton';
import { WebinarListButton } from '../WebinarListButton';

export const Layout = () => {
    // TODO: Fix typing, This needs a global typing or this value to be passed to the component
    const hasRights = useAuthContext().hasRights;
    const footerLinks = [
        { title: 'Footer.Link.Support', urls: { nl: 'https://www.onlinewebinar.com/nl/webinar-support/', en: 'https://www.onlinewebinar.com/support/' } },
        {
            title: 'Footer.Link.TermsOfUse',
            urls: { nl: 'https://www.onlinewebinar.com/nl/terms-and-conditions/', en: 'https://www.onlinewebinar.com/terms-and-conditions/' }
        },
        {
            title: 'Footer.Link.PrivacyPolicy',
            urls: { nl: 'https://www.onlinewebinar.com/nl/privacy-policy/', en: 'https://www.onlinewebinar.com/privacy-policy/' }
        },
        {
            title: 'Footer.Link.CookiePolicy',
            urls: { nl: 'https://www.onlinewebinar.com/nl/cookie-policy/', en: 'https://www.onlinewebinar.com/cookie-policy/' }
        }
    ];

    const { isMainAccount, canBroadcast } = useContext(AuthContext);

    const navItems = useMemo(() => {
        const items: NavBarMenuItem[] = [];
        if (canBroadcast) {
            items.push({
                name: 'create-webinar',
                menuItemComponent: CreateWebinarButton
            });
            items.push({
                name: 'all-webinars',
                menuItemComponent: WebinarListButton
            });
        }
        if (hasRights) {
            items.push({
                name: 'manage',
                menuItemComponent: ManageEnvironmentButton
            });
        }
        if (isMainAccount) {
            items.push({
                name: 'My-webinars',
                menuItemComponent: SubscribedWebinarsButton
            });
        }
        return items;
    }, [isMainAccount, canBroadcast, hasRights]);

    return (
        <Container classNames="menu-left">
            <SideNavBar navBarMenuItems={navItems} />
            <Content footerLinks={footerLinks} />
        </Container>
    );
};
